module.exports = __webpack_public_path__ + "static/media/overlaping-coins.ac94dce2.svg";